import api from "@/apis/bussiness/proxyAPI";
import Crud from "./crudBase";
var crud = new Crud("proxy", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "id",
    }
  },
};
const getters = {
  ...crud.getters
};
const actions = {
  ...crud.actions
};
// 2. Thay vì viết "const mutations = { ... }", hãy ghi đè trực tiếp:
crud.mutations.customItemsData = function(state, items) {
  if (Array.isArray(items)) {
    items.forEach(item => {
      if (item && item.config) {
        item.config_mask = item.config.replace(/^[^:]+:[^@]+/, '***:***');
      }
    });
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
